import React, { Component } from 'react';
import RaisedButton from '@common/RaisedButton';
import Button from '@common/Button';
import Dialog from '@common/Dialog';

export default class CommonDelete extends Component {
  render() {
    let {
      language,
      closeModal,
      onDelete,
      message,
      confirm,
      color,
      button,
      labelButton,
      cancelLabel,
      showCancel=true,
      newVersion=false
    } = this.props;

    return (
      <Dialog
        miniVersion
        modal={false}
        open={(this.props.open != undefined) ? this.props.open : true}
        title={confirm || language.CONFIRM_DELETE}
        onClose={() => closeModal()}
      >
        <h2 className='titlePattern color-lead'>{message}</h2>


        {newVersion ?
          <div className='d-flex align-items-center justify-content-end'>
            <Button
              label={labelButton || language.YES}
              outlined
              variant='normal'
              color={`${color || 'success'}`}
              className='mr-1'
              size={.88}
              style={{border:'none', fontWeight:600}}
              onClick={onDelete}
            />
            {showCancel && <Button
              label={cancelLabel||language.CANCEL}
              outlined
              variant='normal'
              color='default'
              size={.88}
              style={{border:'none', fontWeight:600}}
              onClick={() => closeModal()}
            />}
          </div>
          : <div style={{ float: 'right' }}>
            <RaisedButton
              primary={true}
              circleButton
              icon={`${button || 'fas fa-trash-alt'}`}
              label={labelButton || language.DELETE}
              onClick={onDelete}
              color={`${color || 'danger'}`}
              style={{ fontSize: 15 }}
            />
          </div>
        }
      </Dialog>
    );
  }
}
